import { type TierCollection } from '@mc/api'
import { useBucket } from '@mc/experiments-react'
import { usePlansContext } from '@mc/plans-ui'
import { useStaticData } from '@mc/static-data-react'
import { BUNDLING_TOOLKIT_AND_CERTIFICATES_FLAG_NAME } from '../constants'

// Must match backend: TIER_COLLECTION_METADATA_PREFIX = "PRCNG 698 Bundles 2026"
// backend/domains/growth/lib/prcng_698_bundles_experiment.rb
const TIER_COLLECTION_METADATA_PREFIX = 'PRCNG 698 Bundles 2026 - variant'

export const useExperiment = () => {
  const { isGift } = usePlansContext()
  const bucket = useBucket(BUNDLING_TOOLKIT_AND_CERTIFICATES_FLAG_NAME)
  const { tiersMetadata } = useStaticData<{
    tiersMetadata: TierCollection['metadata']
  }>()

  // Override based on tiersMetadata if present
  const force = tiersMetadata?.startsWith(TIER_COLLECTION_METADATA_PREFIX)
  const isOn =
    force ||
    (!isGift && (bucket === 'control' || bucket?.startsWith('variant')))
  const isVariant = force || (!isGift && bucket?.startsWith('variant'))

  return {
    isOn,
    isVariant,
  }
}
